<template>
  <div class="h-64 w-full mx-auto" style="position: relative;">
    <!-- {{ productsCosts[id] }} -->
    <chart
      v-if="datacollection"
      ref="chart"
      class="max-w-full h-full"
      :chart-data="datacollection"
      :options="options"
    />
  </div>
</template>

<script>
import Chart from '@/components/Chart.js'
import { mapGetters } from 'vuex'
import { format } from '@/utils.js'
const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0
})

export default {
  name: 'ChartProducts',
  components: {
    Chart
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      options: {
        defaultFontFamily: 'Nunito',
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                fontFamily: 'Nunito'
              },
              gridLines: { display: true }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true,
                drawTicks: true
              },
              ticks: {
                fontFamily: 'Nunito',
                beginAtZero: false,
                callback: function(value) {
                  return usd.format(value)
                }
              }
            }
          ]
        },
        legend: {
          display: false
        },
        tooltips: {
          mode: 'index',
          cornerRadius: 10,
          bodySpacing: 6,
          xPadding: 10,
          yPadding: 10,
          titleAlign: 'center',
          titleFontSize: 14,
          backgroundColor: 'rgba(0,0,0,0.75)',
          titleFontFamily: 'Nunito',
          bodyFontFamily: 'Nunito',
          bodyFontSize: 13,
          intersect: false,
          callbacks: {
            label: function(tooltipItem, data) {
              return (
                data.datasets[tooltipItem.datasetIndex].label +
                ': ' +
                format(tooltipItem.yLabel)
              )
            }
          }
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    }
  },

  computed: {
    ...mapGetters('storeModule/invoices', ['productsCosts']),
    datacollection() {
      return {
        labels: [
          ...this.productsCosts[this.id].map(dataPoint =>
            this.$luxon(dataPoint.date.seconds, {
              input: { zone: 'utc', format: 'seconds' },
              output: 'MM/dd'
            })
          )
        ],
        datasets: [
          {
            label: 'Cost',
            borderColor: 'rgba(75, 192, 192, 1)',
            backgroundColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 4,
            fill: false,
            data: [
              ...this.productsCosts[this.id].map(dataPoint =>
                Math.abs(dataPoint.cost).toFixed(2)
              )
            ]
          }
        ]
      }
    }
  }
}
</script>
